<template>
  <div class="share">
      <div class="student">
        <p class="studentName">{{user}}</p>
        <img class="studentNameBg" src="../assets/student_name.png">
      </div>
      <img class="flower" src="../assets/flower.png"/>
      <div class="zan">
        <p class="zan-num" :class="{'zan-num-many':isNumMany}"><span>{{num}}</span></p>
      </div>
      <img v-show="zan" src="../assets/btn_zan.png" alt="点赞" class="btn btn-share" @click="getZan(1)">
      <img v-else src="../assets/btn_zan_disable.png" class="btn btn-share">
      <a v-link="{name:'index'}" class="btn btn-share">
        <img src="../assets/btn_me.png" alt="我也要送">
      </a>
  </div>
</template>

<script>

  module.exports = {
    data: function () {
      return {
        user: '',
        num: 0,
        zan: true,
        isNumMany:false
      }
    },
    ready: function () {
      const self = this
      //此处分享活动首页
      const url = "http://shared.youdao.com/dict/market/2017teacher/final/"
      //此处分享点赞页面
      const shareUrl = window.location.href
      const shareImg = 'http://shared.youdao.com/market/2018teacher/image/share.png';

      ydk.share({
        silence: true,
        shift: true,
        title: "我为老师送上了一份教师节的祝福",
        desc: "快来为我点赞吧",
        imgUrl: shareImg,
        link: shareUrl
      });

      self.user = decodeURIComponent(self.$route.query.userName)

      self.getZan(0)

      if (localStorage.getItem("mobile") === self.$route.query.mobile) {
        self.zan = false
      }
    },
    methods: {
      getZan: function (zan) {
        const self = this
        const mobile = self.$route.query.mobile

        self.sendJsonp({
          api: "http://nd.youdao.com/water",
          data: {'water': zan, 'phoneNum': mobile},
          callback: function (data) {
            if (data.result.code == 200) {
              if(data.data.count>100){
                self.isNumMany=true
              }else {
                self.isNumMany=false
              }
              self.num = data.data.count

              //点赞后置灰，并记录cookie
              if (zan === 1) {
                localStorage.setItem("mobile", mobile)
                self.zan = false
              }
            }
          }
        })
      },
      sendJsonp: function (opt) {
        var options = opt || {};
        var dataSending = options.data || {};
        var callback = options.callback || nothingCall;
        var api = options.api || '';

        var dataListSending = [];
        for (var item in dataSending) {
          if (dataSending.hasOwnProperty(item)) {
            dataListSending.push(item + '=' + dataSending[item]);
          }
        }

        var callbackGlobalMethodName = 'teacher' + (+new Date());
        dataListSending.push('callback=' + callbackGlobalMethodName);
        window[callbackGlobalMethodName] = function (data) {
          temptScript.sourceData = data;
          callback.call(this, data);
        };

        var temptScript = document.createElement('script');
        var jsonpSrc = api + "?" + dataListSending.join("&");
        temptScript.src = jsonpSrc;
        temptScript.onload = temptScript.onreadystatechange = function () {
          window.addEventListener('message', function (e) {
            var sourceData = e.data;
            temptScript.sourceData = e.data;
            if (sourceData) {
              var sourceDataObj = JSON.parse(sourceData);
              window[sourceDataObj.callbackName](sourceDataObj.data);
            }
          });
          if (options.timeout) {
            setTimeout(function () {
              if (!!!temptScript.sourceData) {
                options.timeout.call(this);
              }
            }, 2000);
          }
        };

        if (options.onerror) {
          temptScript.onerror = options.onerror;
        }

        document.getElementsByTagName('head')[0].appendChild(temptScript);

        function nothingCall() {
        }
      }
    }
  }
</script>

<style scoped>
  .share {
    width: 100%;
    height: 100%;
    background: url("../assets/bg_share.png") 0 0/100% 100% no-repeat;
  }

  .student{
    position: relative;
    display: flex;
    justify-content: center;
    width: 5.42rem;
    height: 7rem;
    margin: 20% auto 0;
    background: url("../assets/share_bg_1.png") 0 0/100% 100% no-repeat;
  }
  .studentName{
    position: absolute;
    text-align: center;
    font-size: 0.3rem;
    bottom: 28%;
    left: 50%;
    transform: translateX(-50%);
  }
  .studentNameBg{
    width: 3.48rem;
    height: 1.34rem;
    position: absolute;
    bottom: 10%;
    left: 50%;
    margin-left: -1.74rem;
  }
  .flower{
    display: block;
    width: 1.63rem;
    height: 0.46rem;
    margin: 5% auto;
  }
  .zan{
    position: relative;
    width: 3.91rem;
    height: 0.33rem;
    margin: 0 auto;
    background: url("../assets/zan_num.png") 0 0/100% 100% no-repeat;
    font-size: 0.3rem;
  }

  .zan-num {
    margin: 0;
    position: absolute;
    left: 22%;
  }

  .zan-num-many {
    margin: 0;
    position: absolute;
    left: 17%;
  }

  .btn-share {
    display: inline-block;
    margin: 5% 0 0 9%;
    width: 2.61rem;
    height: 0.67rem;
  }

  @media screen  and (max-height: 600px) {
    .student{
      margin: 16% auto 0;
    }
  }

  @media (device-height:667px) and (-webkit-min-device-pixel-ratio:2){
    .student{
      margin: 16% auto 0;
    }
  }
  @media (device-height:736px) and (-webkit-min-device-pixel-ratio:2){
    .student{
      margin: 16% auto 0;
    }
  }

  @media screen and (max-width: 360px) and (max-height: 540px) {
    .student{
      margin: 8% auto 0;
    }
    .flower{
      margin: 3% auto;
    }
  }

  @media screen and (min-height: 800px)  {
    .student{
      margin: 24% auto 0;
    }
  }
</style>



// WEBPACK FOOTER //
// Share.vue?713fd43c